<template>
  <swiper :options="swiperOption">

    <swiper-slide v-for="item, key in data" :key="key">
      <skill :itemid="key"></skill>
    </swiper-slide>

    <div class="slide-prev" slot="button-prev"></div>
    <div class="slide-next" slot="button-next"></div>
  </swiper>
</template>

<script>
import Skill from '@/components/profile/Skill'
export default {
  props: ['data'],
  components: {
    Skill
  },
  data () {
    return {
      swiperOption: {
        paginationClickable: true,
        nextButton: '.slide-next',
        prevButton: '.slide-prev',
        spaceBetween: 17,
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Slider.vue?56e5af7e